import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqCategories } from "@/data/faq";
import SEO from "@/components/SEO";

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="pt-32 md:pt-40 bg-[#FAF8F5]">
      <SEO
        title="FAQ | Natalia Medical Aesthetics in Kirkland, WA"
        description="Answers about consultations, bookings, safety, aftercare and treatments at Natalia Medical Aesthetics in Kirkland, WA."
        path="/faq"
      />
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">FAQ</div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-[5.2rem] leading-[1.02] tracking-tight">
            Considered answers <em className="italic text-[#8A847C]">to thoughtful questions.</em>
          </h1>
          <p className="mt-10 text-[1.05rem] text-[#5C5C5C] leading-relaxed max-w-2xl">
            If you can't find what you need below, we invite you to reach out — we
            respond personally to every enquiry.
          </p>
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="space-y-20 md:space-y-28">
          {faqCategories.map((cat, ci) => (
            <div key={cat.title} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
              <div className="lg:col-span-4">
                <div className="overline mb-4">Category</div>
                <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight">{cat.title}</h2>
              </div>
              <div className="lg:col-span-8">
                <Accordion type="single" collapsible data-testid={`faq-category-${ci}`}>
                  {cat.items.map((item, ii) => (
                    <AccordionItem key={ii} value={`${ci}-${ii}`} className="border-b border-[#E5E0DA]">
                      <AccordionTrigger data-testid={`faq-q-${ci}-${ii}`} className="text-left font-serif text-xl md:text-2xl tracking-tight hover:no-underline py-6">
                        {item.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-[#5C5C5C] leading-relaxed pb-6 text-base">
                        {item.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 pb-24 md:pb-32">
        <div className="bg-[#F3EFEA] rounded-[28px] p-12 md:p-24 text-center">
          <h3 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight max-w-3xl mx-auto">
            Still have questions?
          </h3>
          <p className="mt-8 text-[#5C5C5C] max-w-lg mx-auto">Reach out — we would love to hear from you.</p>
          <div className="mt-12">
            <Link to="/book" data-testid="faq-cta-btn" className="btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
